<div class="content">

  <!-- not able to connect as player -->
  @if (applicationMode == ApplicationMode.playerMode) {
    <div  class="title">
      {{'playerNotAvailable.title' | translate}}
    </div>
    <div class="info">
      {{'playerNotAvailable.info1' | translate}}
    </div>
    <div class="devices">
      @if ((zoneConnectionPlayerApplicationInfo$ | async) != null) {
        <div>
          {{(zoneConnectionPlayerApplicationInfo$ | async).deviceInfo}}
        </div>
      }
    </div>
    @if ((enableConnect$ | async)) {
      <div class="info infoLast">
        {{'playerNotAvailable.info2' | translate}}
      </div>
    }
    @if (!(enableConnect$ | async)) {
      <div class="info infoLast">
        {{'playerNotAvailable.noConnect.info2' | translate}}
      </div>
    }
  }

  <!-- not able to connect as remote -->
  @if (applicationMode == ApplicationMode.remoteMode) {
    <div  class="title">
      {{'connectNotAvailable.title' | translate}}
    </div>
    <div class="info">
      {{'connectNotAvailable.info1' | translate}}
    </div>
    <div class="devices">
      @if ((zoneConnectionPlayerApplicationInfo$ | async) != null) {
        <div>
          {{(zoneConnectionPlayerApplicationInfo$ | async).deviceInfo}}
        </div>
      }
    </div>
    <div class="info infoLast">
      {{'connectNotAvailable.info2' | translate}}
    </div>
  }



  <div class="button-container">
    <button type="submit"
      (click)="onClose()" class="button button-ok"
      >
      OK
    </button>
  </div>

</div>
